import type { ReactNode } from 'react';
import { CloseFullscreen } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';

/** Keep ticker controls reachable while short windows scroll the metric cards. */
export function ScoreboardFullscreen({
  children,
  onExit,
}: {
  children: ReactNode;
  onExit: () => void;
}) {
  return (
    <Box
      data-testid="scoreboard-fullscreen"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        bgcolor: '#09090b',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1, flexShrink: 0 }}>
        <Tooltip title="Exit ticker mode">
          <IconButton
            aria-label="Exit ticker mode"
            onClick={onExit}
            size="large"
            sx={{ color: '#e4e4e7' }}
          >
            <CloseFullscreen />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        component="main"
        data-testid="scoreboard-ticker-content"
        sx={{
          flex: '1 1 0',
          minHeight: 0,
          minWidth: 0,
          overflowY: 'auto',
          overscrollBehavior: 'contain',
          px: 3,
          pb: 3,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

/** Size all digits from the card width, including the longer sales metrics. */
export function ScoreboardValueFrame({
  children,
  length,
}: {
  children: ReactNode;
  length: number;
}) {
  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 0,
        containerType: 'inline-size',
        '& .rcm-split-flap-display': { gap: '0.35cqw' },
        // Override the legacy viewport-based ticker rules for both display modes.
        '&& .rcm-split-flap-display > [data-mode]': {
          flex: '1 1 0',
          minWidth: 0,
          width: 0,
          fontSize: `min(${95 / length}cqw, 7.25rem)`,
        },
      }}
    >
      {children}
    </Box>
  );
}
